import React from 'react'
import { Script } from 'gatsby'
import { ScriptTagmanager } from './scriptTagmanager'

export function ScriptsDinamicGatsby() {
	return (
		<>
			<ScriptTagmanager />
			<Script type="text/javascript" src="//l.getsitecontrol.com/575m6ow2.js" />
			<Script
				type="text/javascript"
				src="https://onsite.optimonk.com/script.js?account=250992"
				async
			/>
		</>
	)
}
